import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import S from './BorderBottomList.module.css';

const BorderBottomList = ({ date, title, ...props }) => {

  function splitDate(dateString) {
    const [year, month, day] = dateString.split('.');
    return { yearMonth: `${year}.${month}`, day };
  }

  const { yearMonth, day } = splitDate(date);

  return (
    <Link to={props.url} className={S.listElemWrap} key={props.keyprop} >
      <div id={props.divId} className={`${S.listElem} ${props.wrapClass}`}>
        <div className={S.dateWrap}>
          <div className={S.dayDiv}>{day}</div>
          <div className={S.yearMonthDiv}>{yearMonth}</div>
        </div>
        <div className={S.titleDiv}>{title}</div>
        <div className={S.plusDiv}>+</div>
      </div>
    </Link>
  );
}

export default BorderBottomList;
